require('normalize.css/normalize.css');
require('styles/App.css');
import React from 'react';
import Avatar from 'react-avatar';

export default class Vvatar extends React.Component {
	  
  render() {
return (
  <div className="header">
<Avatar googleId="JelenaKocic1975"><br /></Avatar><Avatar facebookId="kjelenak"><br /></Avatar><Avatar skypeId="kjelenak"></Avatar>
</div>

)}}
	 


// WEBPACK FOOTER //
// ./src/components/Avatar.js